import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { attempt } from 'lodash-es';
import { mapKeys } from 'lodash-es';
import { upperFirst } from 'lodash-es';
import { getModifiedProps } from 'react-jsx-highcharts';

var RangeSelectorInput =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeSelectorInput, _Component);

  function RangeSelectorInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RangeSelectorInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RangeSelectorInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "prefixPropsWithInput", function (config) {
      return mapKeys(config, function (value, key) {
        return key.indexOf('input') === 0 ? key : "input".concat(upperFirst(key));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateRangeSelectorInputs", function (config) {
      var chart = _this.props.getChart();

      var inputProps = _this.prefixPropsWithInput(config);

      chart.update({
        rangeSelector: _objectSpread({}, inputProps)
      });
    });

    return _this;
  }

  _createClass(RangeSelectorInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      this.updateRangeSelectorInputs(rest);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var modifiedProps = getModifiedProps(prevProps, this.props);

      if (modifiedProps !== false) {
        this.updateRangeSelectorInputs(modifiedProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      attempt(this.updateRangeSelectorInputs, {
        enabled: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return RangeSelectorInput;
}(Component);

_defineProperty(RangeSelectorInput, "defaultProps", {
  enabled: true
});

export default RangeSelectorInput;